<template>
	<div id="horse-form">
		<div class="row">
			<div class="col-md-6">
				<InputText id="name" name="name" :form="values" :errors="errors" maxLength="50"/>
			</div>
			<div class="col-md-6">
				<InputSelect id="age_year" name="age" :options="age" :form="values" :errors="errors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="sire" name="sire" :form="values" :errors="errors" maxLength="50"/>
			</div>
			<div class="col-md-6">
				<InputText id="dam" name="dam" :form="values" :errors="errors" maxLength="50"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputSelect id="gender_id" name="gender" :options="genders" :form="values" :errors="errors"/>
			</div>
			<div class="col-md-6">
				<InputText id="owner" name="owner" :form="values" :errors="errors" maxLength="50"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputSelect id="equipment" name="Equipment Assigned" :options="equipment" :form="values" :errors="errors" :multiSelect="true" :clearable="true"/>
			</div>
			<div class="col-md-6">
				<div class="checkboxes">
					<InputCheckbox id="ring_worm" name="Horse has Ringworm" :form="values" :errors="errors" />
					<InputCheckbox id="is_away" name="Horse is not at location" :form="values" :errors="errors" />
				</div>
			</div>
		</div>
		<div class="row" v-if="tenant.hasMultiYard">
			<div class="col-md-6">
				<InputSelect id="location_id" name="Location" :options="locations" :form="values" :errors="errors" />
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 text-right">
				<button class="button-action" @click="save">{{ newHorse ? 'Add Horse' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import InputCheckbox from '../Form/InputCheckbox.vue'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText,
		InputCheckbox,
		InputSelect
	},
	props: [
		'horse',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['name', 'age_year', 'gender_id'],
			newHorse: true
		}
	},
	computed: {
		genders() {
			return this.$store.getters['gender/list'].map(gender => {
				return {
					key: gender.id,
					value: gender.gender
				}
			})
		},
		age() {
			return this.$store.getters['age/list'].map(age => {
				return {
					key: age.year,
					value: age.text
				}
			})
		},
		equipment() {
			return this.$store.getters['equipment/list'].map(equipment => {
				return {
					key: equipment.id,
					value: equipment.name
				}
			})
		},
		locations() {
			return this.$store.getters['locations/list'].map(location => {
				return {
					key: location.id,
					value: location.name
				}
			})
		},
		tenant() {
			return this.$store.getters['tenant/get']
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}
			
			const action = this.newHorse ? 'create' : 'update'
			const postActionDescription = this.newHorse ? 'Added' : 'Updated'

			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`horses/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Horse ${this.values.name} ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.horse) {
			this.values = JSON.parse(JSON.stringify(this.horse))
			this.newHorse = false
		}
	},
}
</script>

<style lang="scss">
	@import './../../scss/variables';

	#horse-form {
		.checkboxes {
			background: $input-border-colour;
			padding: 5px;
			.input {
				padding-bottom: 0px;
			}
		}
		.button-action {
			margin-bottom: 80px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Horses/Form.vue